<template>
    <div>
        <table class="w-full d-none d-md-table">
            <thead class="font-bold bg-lightGray h-11">
            <tr>
                <td class="px-2">#</td>
                <td v-if="hasShowDeleteButton" class="px-2">{{ $t('product.count') }}</td>
                <td v-else class="px-2">{{ $t('product.name') }}</td>
                <td class="px-2">{{ $t('unitOfMeasure.short') }}</td>
                <td class="px-2">{{ $t('inventory.amount') }}</td>
                <td class="px-2">{{ $t('inventory.realAmount') }}</td>
                <td class="px-2">{{ $t('inventory.difference') }}</td>
                <td class="px-2">{{ $t('inventory.sumDifference') }}</td>
                <td v-if="hasShowDeleteButton"></td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(piw, index) of piwList" :key="piw.id" class="h-11">
                <td class="px-2">{{ piw.id }}</td>
                <td class="px-2 font-bold text-main">{{ piw.product.name }}</td>
                <td class="px-2">{{ showUnitOfMeasure(piw.product.unitOfMeasure) }}</td>
                <td class="px-2">{{ piw.amount }}</td>
                <td class="px-2">
                    <b-form-input
                        v-if="hasShowDeleteButton"
                        @input="changeResidue"
                        v-model="piw.realAmount"
                        type="number"
                        :state="isValid(piw.realAmount)"
                        style="box-shadow: none; max-width: 100px"
                    />
                    <span v-else>
                        {{ piw.realAmount }}
                </span>
                </td>
                <td class="px-2">
                    <div :class="parseFloat(piw.amount) < parseFloat(piw.realAmount) ? 'bg-green-200 rounded py-1 px-2 font-bold' : 'bg-red-200 rounded py-1 px-2 font-bold'">
                        <span v-if="piw.realAmount">{{ Math.abs(piw.amount - piw.realAmount) }}</span>
                        <font-awesome-icon
                            v-if="parseFloat(piw.amount) < parseFloat(piw.realAmount)"
                            class="icon-link-green"
                            :icon="['fa', 'arrow-up']"
                        />
                        <font-awesome-icon
                            v-if="parseFloat(piw.amount) > parseFloat(piw.realAmount)"
                            class="icon-link-red"
                            :icon="['fa', 'arrow-down']"
                        />
                    </div>
                </td>
                <td class="px-2">
                    <span v-if="piw.realAmount">
                        {{
                            showCurrencyById(piw.product.sellingPriceCurrency.id,
                                Math.abs(piw.amount - piw.realAmount) * parseFloat(piw.product.sellingPrice))
                        }}
                    </span>
                </td>
                <td class="px-2" v-if="hasShowDeleteButton">
                    <img src="/images/Union.png" @click="deleteOneRow(index)" alt="" class="h-6 cursor-pointer">
                </td>
            </tr>
            </tbody>
        </table>
        <table class="w-100 d-md-none">
            <tbody  v-for="(piw, index) of piwList" :key="piw.id" style="border-bottom: 5px solid dimgray">
            <tr>
                <td class="px-2 font-weight-bold">#</td>
                <td class="px-2">{{ piw.id }}</td>
            </tr>
            <tr>
                <td v-if="hasShowDeleteButton" class="px-2 font-weight-bold">{{ $t('product.count') }}</td>
                <td v-else class="px-2 font-weight-bold">{{ $t('product.name') }}</td>
                <td class="px-2" style="width: 50%">{{ piw.product.name }}</td>
            </tr>
            <tr>
                <td class="px-2 font-weight-bold">{{ $t('unitOfMeasure.short') }}</td>
                <td class="px-2">{{ showUnitOfMeasure(piw.product.unitOfMeasure) }}</td>
            </tr>
            <tr>
                <td class="px-2 font-weight-bold">{{ $t('inventory.amount') }}</td>
                <td class="px-2">{{ piw.amount }}</td>
            </tr>
            <tr>
                <td class="px-2 font-weight-bold">{{ $t('inventory.realAmount') }}</td>
                <td class="px-2">
                    <b-form-input
                        v-if="hasShowDeleteButton"
                        @input="changeResidue"
                        v-model="piw.realAmount"
                        type="number"
                        min="0"
                        style="box-shadow: none; max-width: 100px"
                    />
                    <span v-else>
                        {{ piw.realAmount }}
                </span>
                </td>
            </tr>
            <tr>
                <td class="px-2 font-weight-bold">{{ $t('inventory.difference') }}</td>
                <td class="px-2">
                    <div :class="parseFloat(piw.amount) < parseFloat(piw.realAmount) ? 'bg-green-200 rounded py-1 px-2 font-bold' : 'bg-red-200 rounded py-1 px-2 font-bold'">
                        <span v-if="piw.realAmount">{{ Math.abs(piw.amount - piw.realAmount) }}</span>
                        <font-awesome-icon
                            v-if="parseFloat(piw.amount) < parseFloat(piw.realAmount)"
                            class="icon-link-green"
                            :icon="['fa', 'arrow-up']"
                        />
                        <font-awesome-icon
                            v-if="parseFloat(piw.amount) > parseFloat(piw.realAmount)"
                            class="icon-link-red"
                            :icon="['fa', 'arrow-down']"
                        />
                    </div>
                </td>
            </tr>
            <tr>
                <td class="px-2 font-weight-bold">{{ $t('inventory.sumDifference') }}</td>
                <td class="px-2">

                    <span v-if="piw.realAmount">
                        {{
                            showCurrencyById(piw.product.sellingPriceCurrency.id,
                                Math.abs(piw.amount - piw.realAmount) * parseFloat(piw.product.sellingPrice))
                        }}
                    </span>
                </td>
            </tr>
            <tr>
                <td v-if="hasShowDeleteButton"></td>
                <td class="px-2" v-if="hasShowDeleteButton">
                    <img src="/images/Union.png" @click="deleteOneRow(index)" alt="" class="h-6 cursor-pointer">
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import currencyFormatMixin from "@/mixin/currencyFormatMixin";

export default {
    name: "InventoryMakeListTable",
    mixins: [currencyFormatMixin],
    props: {
        piwList: {
            type: Array,
            required: true
        },
        hasShowDeleteButton: {
            type: Boolean,
            default: true
        },
        isSynced: {
            type: Boolean,
            default: false
        }
    },
    computed: {

    },
    methods: {
        deleteOneRow(index) {
            this.$emit('deleteOneRow', index)
        },
        changeResidue() {
            this.$emit('changeResidue')
        },
        isValid(value) {
            return /^[+]?([.]\d+|\d+[.]?\d*)$/.test(value);
        }
    }
}
</script>

<style scoped>
.icon-link-red {
    color: red;
    font-size: 13px;
    position: relative;
    bottom: 2px;
    margin-left: 5px;
}

.icon-link-green {
    color: #04f304;
    font-size: 13px;
    position: relative;
    bottom: 2px;
    margin-left: 5px;
}

.icon-link-grey {
    color: #c9cdd0;
    font-size: 13px;
    position: relative;
    bottom: 2px;
    margin-left: 5px;
}

.checkmark-n {
    color: red;
    font-size: 22px;
    cursor: pointer;
}
</style>
